import { getEmojiFromDashboard } from '@modules/dashboard/helpers';
import { Typography, TypographyProps } from '@mui/material';
import { DashboardViewFragment } from 'generated/graphql';

interface DashboardEmojiProps {
  variant?: TypographyProps['variant'];
  dashboard?: Pick<DashboardViewFragment, 'id' | 'shortMetadata' | 'createdAt'>;
}

export const DashboardEmoji = ({
  dashboard,
  variant = 'h6',
}: DashboardEmojiProps) => {
  const emoji = getEmojiFromDashboard(dashboard);

  return <Typography variant={variant}>{emoji}</Typography>;
};
